import { render, staticRenderFns } from "./AuditLogCardDetail.vue?vue&type=template&id=2d438416&scoped=true&"
import script from "./AuditLogCardDetail.vue?vue&type=script&lang=ts&"
export * from "./AuditLogCardDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d438416",
  null
  
)

export default component.exports